/**
 * The country this visit's connection comes from: the caged.gg Worker reads it from Cloudflare's
 * request data (`/api/geo`, tools/site-worker/). It is a guest's flag in fights (docs/fight.md
 * §10) and the country suggested at signup (L8). Asked once per visit; null when unknown (dev
 * builds have no Worker, offline, or Cloudflare can't tell).
 */
import { isCountry } from '@caged/shared';

let asked: Promise<string | null> | null = null;

export function connectionCountry(): Promise<string | null> {
  asked ??= fetch('/api/geo')
    .then((r) => (r.ok ? (r.json() as Promise<{ country?: string | null }>) : null))
    .then((g) => (isCountry(g?.country) ? g.country : null))
    .catch(() => null);
  return asked;
}
